<template>
  <div class="retransmission">
    <div class="selectionArea">
      <el-input
        v-model="parameter.account"
        placeholder="请输入账号"
        style="margin-right: 10px; width: 200px"
      />
      <el-input
        v-model="parameter.card_num"
        placeholder="请输入卡号"
        style="margin-right: 10px; width: 200px"
      />
      <el-select v-model="parameter.fail_count" placeholder="请选择失败次数">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-select
        v-model="parameter.status"
        placeholder="请选择状态"
        style="margin-left: 10px"
      >
        <el-option
          v-for="item in optionstatuser"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        style="margin-left: 10px"
        type="primary"
        icon="el-icon-search"
        @click="search"
      >搜索</el-button>
      <el-button
        type="primary"
        icon="el-icon-refresh-right"
        @click="reset"
      >重置</el-button>
      <el-button
        type="success"
        icon="el-icon-circle-plus"
        style="position: absolute; right: 40px"
        @click="certwrw"
      >创建</el-button>
      <el-button
        type="warning"
        icon="el-icon-upload"
        size="mini"
        @click="$refs.file.click()"
      >批量导入卡号<input
        ref="file"
        style="display: none"
        type="file"
        multiple
        accept=".xlsx"
        @change="uploadPictures"
      ></el-button>
    </div>
    <div class="mainArea">
      <el-table
        v-loading="loading"
        :data="tableData.list"
        border
        style="width: 100%"
      >
        <el-table-column prop="name" label="名称" width="180" align="center" />
        <el-table-column prop="phone" label="电话" width="180" align="center" />
        <el-table-column
          prop="account"
          label="账号"
          width="180"
          align="center"
        />
        <el-table-column prop="email" label="邮箱" align="center" width="200" />
        <el-table-column
          prop="card_num"
          label="卡号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="status_text"
          label="状态"
          width="150"
          align="center"
        />
        <el-table-column
          prop="fail_count"
          label="失败次数"
          width="180"
          align="center"
        />
        <el-table-column label="失败信息" width="200" align="center">
          <template slot-scope="scope">
            <span :style="{ color: getFailMsgColor(scope.row) }">
              {{ getFailMsg(scope.row) }}
            </span>
          </template>
        </el-table-column>

        <el-table-column
          prop="valid_thru_month"
          label="有效期至（月份）"
          width="180"
          align="center"
        />
        <el-table-column
          prop="valid_thru_day"
          label="有效期至（日）"
          width="180"
          align="center"
        />
        <el-table-column prop="address" align="center" label="操作">
          <template scope="scope">
            <!-- <el-button
              type="primary"
              size="mini"
              @click="copy(scope.row)"
            >复制链接</el-button> -->
            <el-button
              type="primary"
              size="mini"
              @click="edit(scope.row)"
            >修改</el-button>
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row.id)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <PaginationRight
        :total="total"
        :page.sync="parameter.page"
        :limit.sync="parameter.page_size"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>

    <el-dialog
      :title="'卡号'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      width="650px"
    >
      <cardnumberDialog ref="cardnumberview" @updata="updata" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import cardnumberDialog from './components/cardnumberDialog.vue'
import {
  payoneercardlist,
  addlink_config,
  updatalink_config,
  payoneercardimport,
  deletecard
} from '@/api/taobaoLink.js'
export default {
  components: {
    PaginationRight,
    cardnumberDialog
  },
  data() {
    return {
      parameter: {
        fail_count: '', // 公众号
        page: 1, // 当前页
        page_size: 10, // 每页数据量
        account: '',
        card_num: '',
        status: ''
      },
      dialogVisible: false,
      loading: false,
      tableData: {},
      options: [
        {
          value: 1,
          label: '1'
        },
        {
          value: 2,
          label: '2'
        },
        {
          value: 3,
          label: '3'
        }
      ],
      optionstatuser: [
        {
          value: 0,
          label: '未注册'
        },
        {
          value: 1,
          label: '成功'
        },
        {
          value: 2,
          label: '失败'
        },
        {
          value: 3,
          label: '异常'
        },
        {
          value: 4,
          label: '注册中'
        }
      ],
      total: null
    }
  },
  created() {
    this.getListData()
  },
  methods: {
    copy(data) {
      const newdata = data.url
      if (navigator.clipboard) {
        console.log(1)
        navigator.clipboard.writeText(newdata)
      } else {
        const dummyInput = document.createElement('textarea')
        dummyInput.value = newdata
        dummyInput.style.left = '-9999px'
        dummyInput.style.top = '-9999px'
        dummyInput.style.textAlign = 'left'
        dummyInput.style.whiteSpace = 'pre-line'
        document.body.appendChild(dummyInput)
        dummyInput.select()
        document.execCommand('copy')
        document.body.removeChild(dummyInput)
      }
      this.$message.success('复制成功')
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.getListData()
    },
    getFailMsg(row) {
      // ① 如果 status=1 => 什么都不显示
      if (row.status === 1) {
        return ''
      }
      // ③ fail_msg 不为空
      if (row.fail_msg === '充值失败' || row.fail_msg === '正在尝试中') {
        // fail_count >= 5 则 "充值失败"，否则 "正在充值中"
        return row.fail_count >= 5 ? '充值失败' : '正在充值中'
      } else {
        // ④ 其他情况：直接返回后端给的 fail_msg
        return row.fail_msg
      }
    },

    // 2) 根据显示的文本来决定颜色
    getFailMsgColor(row) {
      const finalMsg = this.getFailMsg(row)
      // 如果是“正在充值中”，显示绿色
      // 如果是空字符串或"充值失败"或别的文案 -> 显示红色 (可根据你需求微调)
      if (finalMsg === '正在充值中') {
        return 'green'
      }
      // 这里你也可以针对空字符串做特殊处理，如返回默认颜色
      return 'red'
    },
    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getListData()
    },

    // 搜索
    search() {
      this.parameter.page = 1
      this.getListData()
    },

    // 重置
    reset() {
      this.parameter.page = 1
      this.parameter.fail_count = ''
      this.parameter.account = ''
      this.parameter.card_num = ''
      this.parameter.status = ''
      this.getListData()
    },

    // 获取数据列表
    async getListData() {
      this.loading = true
      try {
        const data = await payoneercardlist(this.parameter)
        this.tableData = data.data
        this.total = data.data.total
      } catch (err) {
        this.$message.error(err)
      }
      this.loading = false
    },

    // 关闭弹窗
    closePopup() {
      this.dialogVisible = false
      this.currentlySelected = undefined
    },

    // 确定
    async determine(form) {
      const bool = this.judge(form)
      if (bool) {
        return
      }
      form.content.forEach((item, i) => {
        console.log('item:', item)
        if (item.img !== null) {
          const regex = /user\/(.+)/
          console.log(item.img)
          const match = item.img.match(regex)
          // console.log('match:', match)
          const fileName = match ? match[1] : null
          // console.log('fileName:', fileName)
          const newImgUrl = fileName ? `user/${fileName}` : null
          item.img = newImgUrl
        }
      })
      try {
        if (form.id === null) {
          await addlink_config(form)
        } else {
          await updatalink_config({ ...form, id: this.currentlySelected.id })
        }
        this.$message.success(this.currentlySelected ? '更新成功' : '创建成功')
        this.getListData()
        this.closePopup()
      } catch (err) {
        // this.$message.error(err)
      }
    },

    // 判断
    judge(form) {
      let text = null
      if (!form.title) {
        text = '请选择标题'
      }
      if (!form.app_id) {
        text = '请选择公众号'
      }
      if (!form.account_id) {
        text = '请选择广告主'
      }
      if (!form.action_id) {
        text = '请选择数据源'
      }
      if (!form.link_code) {
        text = '请填写链接识别码'
      }
      form.content.forEach((item, index) => {
        if (!item.copy_code) {
          text = `第 ${index + 1} 个淘宝口令为空`
        }
        if (!item.img) {
          text = `第 ${index + 1} 个图片为空`
        }
      })
      text && this.$message.warning(text)
      return text
    },

    // 删除
    async handleDelete(id) {
      console.log('id:', id)
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async() => {
        try {
          await deletecard({ id: id })
          this.getListData()
          this.$message.success('删除成功')
        } catch (err) {
          this.$message.error(err)
        }
      })
    },
    certwrw() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.cardnumberview.send(1)
      })
    },
    updata() {
      this.dialogVisible = false
      this.getListData()
    },
    edit(item) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.cardnumberview.send(2, item)
      })
    },
    // 上传图片回调 图片(不是裁剪上传)
    async uploadPictures(e) {
      console.log('e.target.files', e.target.files)
      // eslint-disable-next-line eqeqeq
      const extension = e.target.files[0].name.split('.').slice(-1) == 'xlsx'
      if (!extension) {
        this.$message.warning('上传模板只能是xlsx格式!')
        return
      }
      const form = new FormData()
      form.append('file', e.target.files[0])
      // form.append('merchant_id', this.parameter.merchant_id)
      // form.append('type', 1)
      // const file = e.target.files
      const data = await payoneercardimport(form)
      // this.$message.success('删除成功')
      // this.getListData()
      console.log('data', data)
      // this.name = e.target.files[0].name
      // console.log('data', data)
      // this.parameter.certificate_file_path = data.data.path
      // console.log('e', e, e.target.files[0])
      // const fileIfon = e.target.files[0]
    }
  }
}
</script>

<style lang="less" scoped>
.retransmission {
  width: 95%;
  margin: 0 auto;
  margin-top: 30px;
}
.selectionArea {
  display: flex;
}

.mainArea {
  margin-top: 30px;
}
</style>
